"use strict";

import Axios from "axios";
import configuration from "../../configuration";
import OfficceService from "./OfficceService";

export default class ContractService {

  static validade(contract) {
    let errors = []
    if (!contract.company) errors.push('empresa')
    if (!contract.client) errors.push('cliente')

    if (errors.length > 0) return errors
    else return null
  }

  static async findInitialContracts() {
    try {
      let response = await Axios.get(`${configuration.apiHost}contracts/initial`);
      return response.data;
    } catch (error) {
      throw new Error(error);
    }
  }
  static async findAll() {
    try {
      let response = await Axios.get(`${configuration.apiHost}contracts/`);
      return response.data;
    } catch (error) {
      throw new Error(error);
    }
  }

  static async create(contract) {
    try {
      let saved = await Axios.post(`${configuration.apiHost}contracts/`, contract);
      return saved.data;
    } catch (error) {
      throw new Error(error);
    }
  }

  static async update(contract) {
    try {
      let updated = await Axios.put(`${configuration.apiHost}contracts/`, contract);
      return updated.data;
    } catch (error) {
      throw new Error(error);
    }
  }


  static async budgetToContract(budget, contract) {
    if (!contract) contract = {
      address: {}
    }
    contract.client = budget.client
    contract.company = budget.company
    contract.departments = []
    contract.amount = 0
    // planilhas analiticas
    for (let i = 0; i < budget.analyticalWorksheets.length; i++) {
      const element = budget.analyticalWorksheets[i];
      let off = await OfficceService.getByName(element.header.office.description)
      contract.amount += (element.header.numberOfEmployees * element.header.amountMonthly)
      contract.departments.push({
        name: `${element.header.deliveryAddress.sector}`,
        lastName: `${element.header.professionalCategory.occupation}`,
        address: element.header.deliveryAddress,
        numberOfEmployees: element.header.numberOfEmployees,
        amountMonthly: element.header.amountMonthly,
        unitOfMeasurement: element.header.unitOfMeasurement,
        office: off,
        collectiveConvention: element.header.collectiveConvention,
        additionalInfo: element.header.additionalInfo,
        mainNotes: element.header.mainNotes,
        professionalCategory: element.header.professionalCategory,
        complementariesNotes: element.header.complementariesNotes,
        materials: element.moduleFive,

      })
    }
    return contract
  }

} // class



// WEBPACK FOOTER //
// ./src/service/ContractService.js